import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import './ExamScheduleList.css';
import SwapRequestModal from './SwapRequestModal';
import { KTSVG } from '../../../_metronic/helpers'
import Swal from 'sweetalert2';
import SwapRequestsPanel from './SwapRequestsPanel';
import { StartExamModal } from './StartExamModal';
import { IssueModal } from './IssueModal';
import SwapAdBoard from './SwapAdBoard';
import QrScannerModal from './QrScannerModal';
import {ExamRulesApprovalModal, useExamRulesApproval} from './examRulesApproval';
import {CalendarExportButton, createCalendarDateTime} from '../../utils/calendarExport';

const API_URL = process.env.REACT_APP_API_URL;
const GET_PUBLISHED_PERIODS_URL = `${API_URL}/Custom/GetPublishedExamPeriods`;
const GET_TIME_SLOTS_URL = `${API_URL}/Custom/GetTimeSlots`;
const GET_DUTIES_URL = `${API_URL}/Custom/GetMyScheduleTeacher`;
const GET_COURSES_URL = `${API_URL}/Custom/GetMyCourses`;
const GET_SWAP_STATUS_URL = `${API_URL}/Custom/GetSwapRequestStatus`;
const GET_SWAP_STATUSES_URL = `${API_URL}/Custom/GetSwapRequestStatuses`;
const GET_MY_SWAP_REQUESTS_URL = `${API_URL}/Custom/GetMySwapRequests`;
const GET_INCOMING_SWAP_REQUESTS_URL = `${API_URL}/Custom/GetIncomingSwapRequests`;
const POST_SWAP_DECISION_URL = `${API_URL}/Custom/DecideSwapRequest`;
const GET_MY_SUPERVISOR_BUILDINGS_URL = `${API_URL}/Custom/GetMySupervisorBuildings`;
const GET_BUILDING_SCHEDULE_URL = `${API_URL}/Custom/GetBuildingSchedule`;

export default function MyScheduleComponent() {
    // Hangi sekme (desktop ve mobile) aktif: 'duties' veya 'courses'
    const [activeTab, setActiveTab] = useState('duties');

    // Yayımlanmış dönemler
    const [publishedPeriods, setPublishedPeriods] = useState([]);
    const [isLoadingPeriods, setIsLoadingPeriods] = useState(false);

    const [myRequests, setMyRequests] = useState([]);
    const [incomingRequests, setIncomingRequests] = useState([]);

    // Masaüstü “Sınav Görevleri”
    const [selectedDutyPeriodIndex, setSelectedDutyPeriodIndex] = useState(0);
    const [dutyTimeSlots, setDutyTimeSlots] = useState([]);
    const [dutyDistinctTimes, setDutyDistinctTimes] = useState([]);
    const [dutyWeeks, setDutyWeeks] = useState([]);
    const [dutyCurrentWeek, setDutyCurrentWeek] = useState(0);
    const [dutySchedule, setDutySchedule] = useState([]);
    const [isLoadingDuties, setIsLoadingDuties] = useState(false);

    // Masaüstü “Verdiğim Dersler”
    const [selectedCoursePeriodIndex, setSelectedCoursePeriodIndex] = useState(0);
    const [courseTimeSlots, setCourseTimeSlots] = useState([]);
    const [courseDistinctTimes, setCourseDistinctTimes] = useState([]);
    const [courseWeeks, setCourseWeeks] = useState([]);
    const [courseCurrentWeek, setCourseCurrentWeek] = useState(0);
    const [courseSchedule, setCourseSchedule] = useState([]);
    const [isLoadingCourses, setIsLoadingCourses] = useState(false);

    // Mobil tüm dönemlerin görevleri ve ders sınavları
    const [aggregatedDuties, setAggregatedDuties] = useState([]);
    const [aggregatedCourses, setAggregatedCourses] = useState([]);

    const [supervisorBuildings, setSupervisorBuildings] = useState([]); // { id, name }
    const [selectedBuildingIndex, setSelectedBuildingIndex] = useState(0);
    const [selectedBuildingPeriodIndex, setSelectedBuildingPeriodIndex] = useState(0);
    const [buildingSchedule, setBuildingSchedule] = useState([]); // slot + görev bilgisi
    const [isLoadingBuilding, setIsLoadingBuilding] = useState(false);
    const hasBuildingSupervisorRole = supervisorBuildings.length > 0;

    const [showSwapModal, setShowSwapModal] = useState(false);
    const [swapSlotId, setSwapSlotId] = useState(null);

    const [swapStatuses, setSwapStatuses] = useState({});
    const [dutyRefreshToken, setDutyRefreshToken] = useState(0);

    const [showStartModal, setShowStartModal] = useState(false);
    const [showIssueModal, setShowIssueModal] = useState(false);
    const [showQrScanner, setShowQrScanner] = useState(false);
    const [qrExamContext, setQrExamContext] = useState(null);
    const [selectedExam, setSelectedExam] = useState(null); 
    const selectedBuilding = supervisorBuildings[selectedBuildingIndex] || null;
    const buildingPeriods = useMemo(() => {
        if (!publishedPeriods.length) return [];

        const periodIds = selectedBuilding?.periodIds;
        if (!Array.isArray(periodIds) || periodIds.length === 0) {
            return publishedPeriods;
        }

        const allowedPeriodIds = new Set(periodIds.map(Number));
        return publishedPeriods.filter(period => allowedPeriodIds.has(Number(period.id)));
    }, [publishedPeriods, selectedBuilding]);
    const selectedBuildingPeriod = buildingPeriods[selectedBuildingPeriodIndex] || buildingPeriods[0] || null;
    const activeRulePeriod = useMemo(() => {
        if (!publishedPeriods.length) return null;
        if (activeTab === 'duties') return publishedPeriods[selectedDutyPeriodIndex] || null;
        if (activeTab === 'courses') return publishedPeriods[selectedCoursePeriodIndex] || null;
        if (activeTab === 'building') return selectedBuildingPeriod;
        return null;
    }, [activeTab, publishedPeriods, selectedBuildingPeriod, selectedCoursePeriodIndex, selectedDutyPeriodIndex]);
    const activeRuleScope = activeTab === 'duties' ? 'duties' : activeTab === 'courses' ? 'staff' : activeTab === 'building' ? 'building' : null;
    const examRulesApproval = useExamRulesApproval(activeRulePeriod?.id, activeRuleScope);
    const canViewActiveTab = !activeRuleScope || examRulesApproval.canView;

    const handleModalSaved = (type, exam) => {
        console.log(exam);
        setBuildingSchedule(prev =>
            prev.map(item =>
                item.timeSlotId === exam.timeSlotId && item.classroomId === exam.classroomId
                    ? { ...item, ...(type === 'start' ? { hasStartReport: true } : { hasIssue: true }) }
                    : item
            )
        );
    };

    const openStartModal = (exam) => {
        setSelectedExam(exam);      // exam objesinde timeSlotId, classroomId vs. var
        setShowStartModal(true);
    };

    const openIssueModal = (exam) => {
        setSelectedExam(exam);
        setShowIssueModal(true);
    };

    const openQrScanner = (exam) => {
        setQrExamContext(exam);
        setShowQrScanner(true);
    };

    const closeQrScanner = () => {
        setShowQrScanner(false);
        setQrExamContext(null);
    };

    // Modaldan kapanış dönerken state’i sıfırla
    const closeStartModal = () => {
        setShowStartModal(false);
        setSelectedExam(null);
    };
    const closeIssueModal = () => {
        setShowIssueModal(false);
        setSelectedExam(null);
    };

    const refreshSwapData = () => {
        axios.get(GET_MY_SWAP_REQUESTS_URL)
            .then(({ data }) => setMyRequests(data || []))
            .catch(console.error);

        axios.get(GET_INCOMING_SWAP_REQUESTS_URL)
            .then(({ data }) => setIncomingRequests(data || []))
            .catch(console.error);
    };

    const refreshDutyCalendarData = () => {
        refreshSwapData();
        setDutyRefreshToken(value => value + 1);
    };

    useEffect(() => {
        console.log(buildingSchedule)
    }, [buildingSchedule]);

    useEffect(() => {
        setIsLoadingPeriods(true);
        axios.get(GET_PUBLISHED_PERIODS_URL)
            .then(({ data }) => setPublishedPeriods(data.filter(p => p.isPublished)))
            .catch(console.error)
            .finally(() => setIsLoadingPeriods(false));

        // Swap istekleri
        axios.get(GET_MY_SWAP_REQUESTS_URL).then(({ data }) => setMyRequests(data || [])).catch(console.error);
        axios.get(GET_INCOMING_SWAP_REQUESTS_URL).then(({ data }) => setIncomingRequests(data || [])).catch(console.error);

        // Kişinin bina sorumlulukları
        axios.get(GET_MY_SUPERVISOR_BUILDINGS_URL)
            .then(({ data }) => setSupervisorBuildings(data || []))
            .catch(console.error);
    }, []);

    useEffect(() => {
        if (selectedBuildingPeriodIndex >= buildingPeriods.length) {
            setSelectedBuildingPeriodIndex(0);
        }
    }, [buildingPeriods.length, selectedBuildingPeriodIndex]);

    useEffect(() => {
        if (activeTab !== 'building') return;
        if (!hasBuildingSupervisorRole) return;
        if (!selectedBuildingPeriod) return;
        if (!canViewActiveTab) {
            setBuildingSchedule([]);
            return;
        }

        if (!selectedBuilding) return;

        setIsLoadingBuilding(true);
        axios.get(`${GET_BUILDING_SCHEDULE_URL}?buildingId=${selectedBuilding.id}&periodId=${selectedBuildingPeriod.id}`)
            .then(({ data }) => setBuildingSchedule(data || []))
            .catch(error => {
                console.error(error);
                setBuildingSchedule([]);
            })
            .finally(() => setIsLoadingBuilding(false));
    }, [activeTab, hasBuildingSupervisorRole, selectedBuilding, selectedBuildingPeriod, canViewActiveTab]);

    useEffect(() => {
        setIsLoadingPeriods(true);
        axios.get(GET_PUBLISHED_PERIODS_URL)
            .then(({ data }) => setPublishedPeriods(data.filter(p => p.isPublished)))
            .catch(console.error)
            .finally(() => setIsLoadingPeriods(false));

        // Benim taleplerim
        axios.get(GET_MY_SWAP_REQUESTS_URL)
            .then(({ data }) => setMyRequests(data || []))
            .catch(console.error);

        // Bana gelen talepler
        axios.get(GET_INCOMING_SWAP_REQUESTS_URL)
            .then(({ data }) => setIncomingRequests(data || []))
            .catch(console.error);
    }, []);

    // 2) Talepleri onay/red etme fonksiyonu
    const decideRequest = (requestId, approve, slotId) => {
        axios.post(POST_SWAP_DECISION_URL, { requestId, approve, selectedTargetSlotId: slotId })
            .then(() => {
                Swal.fire({
                    title: approve ? 'Talep Onaylandı ve Değişim Tamamlandı' : 'Talep Reddedildi',
                    icon: approve ? 'success' : 'error',
                    confirmButtonText: 'Tamam'
                });
                // Gelen talepler listesini güncelle
                setIncomingRequests(prev => prev.filter(r => r.id !== requestId));
                refreshDutyCalendarData();
            })
            .catch(console.error);
    };

    // 1) Yayımlanmış dönemleri yükle
    useEffect(() => {
        setIsLoadingPeriods(true);
        axios.get(GET_PUBLISHED_PERIODS_URL)
            .then(({ data: periods }) => {
                const published = periods.filter(period => period.isPublished);
                setPublishedPeriods(published);
            })
            .catch(console.error)
            .finally(() => setIsLoadingPeriods(false));
    }, []);

    // 2a) Masaüstü: “Sınav Görevleri” verisini ve zaman aralıklarını yükle
    useEffect(() => {
        if (activeTab !== 'duties') return;
        if (!publishedPeriods.length) return;
        if (!canViewActiveTab) {
            setDutyTimeSlots([]);
            setDutySchedule([]);
            return;
        }

        const period = publishedPeriods[selectedDutyPeriodIndex];
        setIsLoadingDuties(true);
        setDutyTimeSlots([]);
        setDutySchedule([]);

        axios.get(`${GET_TIME_SLOTS_URL}?examPeriodId=${period.id}`)
            .then(({ data: slots }) => {
                setDutyTimeSlots(slots);

                const times = Array.from(new Set(slots.map(s => `${s.startTime}-${s.endTime}`)))
                    .map(str => {
                        const [startTime, endTime] = str.split('-');
                        return { startTime, endTime };
                    })
                    .sort((a, b) => a.startTime.localeCompare(b.startTime));
                setDutyDistinctTimes(times);

                const dates = Array.from(new Set(slots.map(s => s.exactDate.split('T')[0]))).sort();
                if (!dates.length) return [];
                const firstDate = new Date(dates[0]);
                const lastDate = new Date(dates.at(-1));
                const firstMonday = new Date(firstDate);
                firstMonday.setDate(firstDate.getDate() - ((firstDate.getDay() + 6) % 7));
                const lastSunday = new Date(lastDate);
                lastSunday.setDate(lastDate.getDate() + (6 - ((lastDate.getDay() + 6) % 7)));
                const weeksArray = [];
                for (let d = new Date(firstMonday); d <= lastSunday; d.setDate(d.getDate() + 7)) {
                    weeksArray.push(
                        Array.from({ length: 7 }, (_, i) => {
                            const day = new Date(d);
                            day.setDate(d.getDate() + i);
                            return day.toISOString().split('T')[0];
                        })
                    );
                }
                setDutyWeeks(weeksArray);

                return axios.get(`${GET_DUTIES_URL}?periodId=${period.id}`);
            })
            .then(({ data }) => {
                setDutySchedule(data || []);
            })
            .catch(console.error)
            .finally(() => setIsLoadingDuties(false));
    }, [activeTab, publishedPeriods, selectedDutyPeriodIndex, canViewActiveTab, dutyRefreshToken]);

    // 2b) Masaüstü: “Verdiğim Dersler” verisini ve zaman aralıklarını yükle
    useEffect(() => {
        if (activeTab !== 'courses') return;
        if (!publishedPeriods.length) return;
        if (!canViewActiveTab) {
            setCourseTimeSlots([]);
            setCourseSchedule([]);
            return;
        }

        const period = publishedPeriods[selectedCoursePeriodIndex];
        setIsLoadingCourses(true);
        setCourseTimeSlots([]);
        setCourseSchedule([]);

        axios.get(`${GET_TIME_SLOTS_URL}?examPeriodId=${period.id}`)
            .then(({ data: slots }) => {
                setCourseTimeSlots(slots);

                const times = Array.from(new Set(slots.map(s => `${s.startTime}-${s.endTime}`)))
                    .map(str => {
                        const [startTime, endTime] = str.split('-');
                        return { startTime, endTime };
                    })
                    .sort((a, b) => a.startTime.localeCompare(b.startTime));
                setCourseDistinctTimes(times);

                const dates = Array.from(new Set(slots.map(s => s.exactDate.split('T')[0]))).sort();
                if (!dates.length) return [];
                const firstDate = new Date(dates[0]);
                const lastDate = new Date(dates.at(-1));
                const firstMonday = new Date(firstDate);
                firstMonday.setDate(firstDate.getDate() - ((firstDate.getDay() + 6) % 7));
                const lastSunday = new Date(lastDate);
                lastSunday.setDate(lastDate.getDate() + (6 - ((lastDate.getDay() + 6) % 7)));
                const weeksArray = [];
                for (let d = new Date(firstMonday); d <= lastSunday; d.setDate(d.getDate() + 7)) {
                    weeksArray.push(
                        Array.from({ length: 7 }, (_, i) => {
                            const day = new Date(d);
                            day.setDate(d.getDate() + i);
                            return day.toISOString().split('T')[0];
                        })
                    );
                }
                setCourseWeeks(weeksArray);

                return axios.get(`${GET_COURSES_URL}?periodId=${period.id}`);
            })
            .then(({ data }) => {
                setCourseSchedule(data || []);
            })
            .catch(console.error)
            .finally(() => setIsLoadingCourses(false));
    }, [activeTab, publishedPeriods, selectedCoursePeriodIndex, canViewActiveTab]);

    // 3) Haftaları sıfırla
    useEffect(() => {
        if (dutyWeeks.length) setDutyCurrentWeek(0);
    }, [dutyWeeks]);
    useEffect(() => {
        if (courseWeeks.length) setCourseCurrentWeek(0);
    }, [courseWeeks]);

    // 4a) Mobil için görevleri birleştir
    useEffect(() => {
        if (activeTab !== 'duties') return;
        if (!publishedPeriods.length || !canViewActiveTab) {
            setAggregatedDuties([]);
            return;
        }

        const period = publishedPeriods[selectedDutyPeriodIndex];
        if (!period) return;

        axios.get(`${GET_TIME_SLOTS_URL}?examPeriodId=${period.id}`)
            .then(({ data: slots }) =>
                axios.get(`${GET_DUTIES_URL}?periodId=${period.id}`)
                    .then(({ data: duties }) => ({ periodName: period.name, slots, duties }))
            )
            .then(({periodName, slots, duties}) => {
                const all = [];
                duties.forEach(duty => {
                    const slot = slots.find(s => s.id === duty.slotId);
                    if (!slot) return;
                    all.push({
                        slotId: duty.slotId,              // <<< slotId ekledik
                        periodName,
                        date: slot.exactDate.split('T')[0],
                        startTime: slot.startTime,
                        endTime: slot.endTime,
                        isOff: duty.isOff,
                        roleName: duty.roleName,
                        examName: duty.examName,
                        examId: duty.examId,
                        examScheduleId: duty.examScheduleId,
                        classroomId: duty.classroomId,
                        examDeliveryMethod: duty.examDeliveryMethod
                    });
                });
                setAggregatedDuties(all);
            })
            .catch(console.error);
    }, [activeTab, publishedPeriods, selectedDutyPeriodIndex, canViewActiveTab, dutyRefreshToken]);

    // 4b) Mobil için ders sınavlarını birleştir
    useEffect(() => {
        if (activeTab !== 'courses') return;
        if (!publishedPeriods.length || !canViewActiveTab) {
            setAggregatedCourses([]);
            return;
        }

        const period = publishedPeriods[selectedCoursePeriodIndex];
        if (!period) return;

        axios.get(`${GET_TIME_SLOTS_URL}?examPeriodId=${period.id}`)
            .then(({ data: slots }) =>
                axios.get(`${GET_COURSES_URL}?periodId=${period.id}`)
                    .then(({ data: exams }) => ({ periodName: period.name, slots, exams }))
            )
            .then(({periodName, slots, exams}) => {
                const all = [];
                exams.forEach(exam => {
                    const slot = slots.find(s => s.id === exam.slotId);
                    if (!slot) return;
                    all.push({
                        periodName,
                        date: slot.exactDate.split('T')[0],
                        startTime: slot.startTime,
                        endTime: slot.endTime,
                        courseCode: exam.courseCode,
                        courseName: exam.courseName,
                        examName: exam.examName,
                        classroomCode: exam.classroomCode,
                        studentCount: exam.studentCount
                    });
                });
                setAggregatedCourses(all);
            })
            .catch(console.error);
    }, [activeTab, publishedPeriods, selectedCoursePeriodIndex, canViewActiveTab]);

    // 5) Swap durumlarını toplu oku
    useEffect(() => {
        const slotIds = dutySchedule
            .map(d => d.slotId)
            .filter(Boolean);

        if (!slotIds.length) {
            setSwapStatuses({});
            return;
        }

        axios.post(GET_SWAP_STATUSES_URL, slotIds)
            .then(({ data }) => {
                const map = {};
                (data || []).forEach(item => {
                    map[item.slotId] = {
                        hasRequest: !!item.hasRequest,
                        status: item.status || null
                    };
                });
                setSwapStatuses(map);
            })
            .catch(() => setSwapStatuses({}));
    }, [dutySchedule]);

    // openSwapModal güncellemesi
    const openSwapModal = (slot) => {
        const hasRequest = !!swapStatuses[slot.id]?.hasRequest;
        if (hasRequest) {
            const cachedStatus = swapStatuses[slot.id]?.status;
            const statusPromise = cachedStatus
                ? Promise.resolve({ data: { status: cachedStatus } })
                : axios.get(`${GET_SWAP_STATUS_URL}?slotId=${slot.id}`);

            statusPromise
                .then(({ data: { status } }) => {
                    const blocked = [
                        'Kullanıcı Onayı Bekliyor',
                        'Yönetim Onayı Bekliyor',
                        'Onaylandı'
                    ];
                    if (blocked.includes(status)) {
                        Swal.fire({
                            title: 'Talep Durumu',
                            text: `Mevcut talep durumu: ${status}`,
                            icon: 'info',
                            confirmButtonText: 'Tamam'
                        });
                    } else {
                        setSwapSlotId(slot.id);
                        setShowSwapModal(true);
                    }
                })
                .catch(err => {
                    console.error(err);
                    Swal.fire({
                        title: 'Hata',
                        text: 'Talep durumu alınırken bir hata oluştu.',
                        icon: 'error',
                        confirmButtonText: 'Kapat'
                    });
                });
        } else {
            setSwapSlotId(slot.id);
            setShowSwapModal(true);
        }
    };

    // Masaüstü görünür günler
    const visibleDutyDays = useMemo(() => {
        if (!dutyWeeks.length) return [];
        return dutyWeeks[dutyCurrentWeek].filter(date => {
            const dayOfWeek = new Date(date).getDay();
            return (dayOfWeek > 0 && dayOfWeek < 6) || dutyTimeSlots.some(s => s.exactDate.startsWith(date));
        });
    }, [dutyWeeks, dutyCurrentWeek, dutyTimeSlots]);

    const visibleCourseDays = useMemo(() => {
        if (!courseWeeks.length) return [];
        return courseWeeks[courseCurrentWeek].filter(date => {
            const dayOfWeek = new Date(date).getDay();
            return (dayOfWeek > 0 && dayOfWeek < 6) || courseTimeSlots.some(s => s.exactDate.startsWith(date));
        });
    }, [courseWeeks, courseCurrentWeek, courseTimeSlots]);

    // Mobil benzersiz tarihler
    const mobileDutyDates = useMemo(
        () => [...new Set(aggregatedDuties.map(d => d.date))].sort(),
        [aggregatedDuties]
    );
    const mobileCourseDates = useMemo(
        () => [...new Set(aggregatedCourses.map(c => c.date))].sort(),
        [aggregatedCourses]
    );

    const calendarEvents = useMemo(() => {
        if (activeTab === 'duties') {
            const periodName = publishedPeriods[selectedDutyPeriodIndex]?.name;
            return dutySchedule.flatMap(duty => {
                const slot = dutyTimeSlots.find(s => s.id === duty.slotId);
                if (!slot) return [];
                const date = slot.exactDate.split('T')[0];
                return [{
                    uid: `teacher-duty-${duty.examScheduleId || `${duty.slotId}-${duty.classroomId || 'off'}`}`,
                    title: duty.isOff ? 'Sınav Görevi (Diğer)' : `${duty.roleName || 'Sınav Görevi'} - ${duty.examName || ''}`.trim(),
                    start: createCalendarDateTime(date, slot.startTime),
                    end: createCalendarDateTime(date, slot.endTime),
                    location: [duty.buildingName, duty.classroomCode].filter(Boolean).join(' - '),
                    description: [periodName, duty.examName, duty.examDeliveryMethod].filter(Boolean).join('\n'),
                }];
            });
        }

        if (activeTab === 'courses') {
            const periodName = publishedPeriods[selectedCoursePeriodIndex]?.name;
            return courseSchedule.flatMap(exam => {
                const slot = courseTimeSlots.find(s => s.id === exam.slotId);
                if (!slot) return [];
                const date = slot.exactDate.split('T')[0];
                return [{
                    uid: `teacher-course-exam-${exam.examScheduleId || `${exam.slotId}-${exam.classroomCode || exam.courseCode || exam.examName}`}`,
                    title: `${exam.courseCode || ''} ${exam.examName || 'Sınav'}`.trim(),
                    start: createCalendarDateTime(date, slot.startTime),
                    end: createCalendarDateTime(date, slot.endTime),
                    location: exam.classroomCode,
                    description: [
                        periodName,
                        exam.courseName,
                        exam.studentCount ? `${exam.studentCount} kişi` : null,
                    ]
                        .filter(Boolean)
                        .join('\n'),
                }];
            });
        }

        if (activeTab === 'building') {
            return buildingSchedule.map(exam => ({
                uid: `building-exam-${exam.examScheduleId || `${exam.timeSlotId || exam.date}-${exam.classroomId || exam.classroomCode}-${exam.examName}`}`,
                title: `${exam.examName || 'Sınav'}${exam.classroomCode ? ` - ${exam.classroomCode}` : ''}`,
                start: createCalendarDateTime(exam.date, exam.startTime),
                end: createCalendarDateTime(exam.date, exam.endTime),
                location: [selectedBuilding?.name, exam.classroomCode].filter(Boolean).join(' - '),
                description: [
                    selectedBuildingPeriod?.name,
                    exam.studentCount ? `${exam.studentCount} kişi` : null,
                    ...(exam.roles || []).map(role => `${role.roleName}: ${role.teacherName}`),
                ]
                    .filter(Boolean)
                    .join('\n'),
            }));
        }

        return [];
    }, [
        activeTab,
        buildingSchedule,
        courseSchedule,
        courseTimeSlots,
        dutySchedule,
        dutyTimeSlots,
        publishedPeriods,
        selectedBuilding,
        selectedBuildingPeriod,
        selectedCoursePeriodIndex,
        selectedDutyPeriodIndex,
    ]);

    const calendarFileName = useMemo(() => {
        if (activeTab === 'duties') {
            return `${publishedPeriods[selectedDutyPeriodIndex]?.name || 'sinav'}-gorev-takvimim`;
        }
        if (activeTab === 'courses') {
            return `${publishedPeriods[selectedCoursePeriodIndex]?.name || 'sinav'}-ders-sinavlari`;
        }
        if (activeTab === 'building') {
            return `${selectedBuilding?.name || 'bina'}-sinav-takvimi`;
        }
        return 'takvim';
    }, [
        activeTab,
        publishedPeriods,
        selectedBuilding,
        selectedCoursePeriodIndex,
        selectedDutyPeriodIndex,
    ]);

    const renderBuildingRows = () => {
        if (!buildingSchedule.length)
            return <p className="text-muted">Bu bina için kayıtlı sınav yok.</p>;

        // Tarih → Saat → Salon gruplama
        const grouped = buildingSchedule.reduce((acc, curr) => {
            const dayKey = curr.date;
            const hourKey = `${curr.startTime}-${curr.endTime}`;
            const roomKey = curr.classroomCode;
            acc[dayKey] = acc[dayKey] || {};
            acc[dayKey][hourKey] = acc[dayKey][hourKey] || {};
            acc[dayKey][hourKey][roomKey] = acc[dayKey][hourKey][roomKey] || [];
            acc[dayKey][hourKey][roomKey].push(curr);
            return acc;
        }, {});

        return Object.entries(grouped)
            .sort((a, b) => a[0].localeCompare(b[0]))
            .map(([date, hours]) => (
                <div key={date} className="card mb-5">
                    <div className="card-header bg-success text-white fw-bold text-center">
                        {new Date(date).toLocaleDateString('tr-TR', {
                            weekday: 'long',
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                        })}
                    </div>
                    <ul className="list-group list-group-flush">
                        {Object.entries(hours)
                            .sort((a, b) => a[0].localeCompare(b[0]))
                            .map(([hour, rooms]) =>
                                Object.entries(rooms)
                                    .sort((a, b) => a[0].localeCompare(b[0]))
                                    .map(([room, exams], idx) => {
                                        const [start, end] = hour.split('-');

                                        return (
                                            <li key={`${hour}-${room}-${idx}`} className="list-group-item position-relative">
                                                <div className="fw-semibold mb-1">
                                                    {start.substring(0, 5)}-{end.substring(0, 5)} | {room}
                                                </div>

                                                {exams.map((ex, i) => {
                                                    // Salon başkanı önce
                                                    const sortedRoles = [...ex.roles].sort((a, b) =>
                                                        a.roleName === 'Salon Başkanı'
                                                            ? -1
                                                            : b.roleName === 'Salon Başkanı'
                                                                ? 1
                                                                : 0
                                                    );

                                                    /* TODO: ex.hasStartReport / ex.hasIssue
                                                     *  backend’den boolean dönün
                                                     */
                                                    const hasStartReport = ex.hasStartReport;
                                                    const hasIssue = ex.hasIssue;

                                                    return (
                                                        <div key={i} className="d-flex justify-content-between">
                                                            {/* ▼ SOL: sınav bilgisi */}
                                                            <div className="me-2">
                                                                <strong>{ex.examName}</strong> ({ex.studentCount} kişi)
                                                                <br />
                                                                {sortedRoles.map((r, j) => (
                                                                    <small key={j} className="text-muted">
                                                                        {r.roleName}: {r.teacherName}
                                                                        {j < sortedRoles.length - 1 ? ', ' : ''}
                                                                    </small>
                                                                ))}
                                                            </div>

                                                            {/* ▼ SAĞ: buton sütunu */}
                                                            <div className="d-flex flex-column align-items-end gap-1">
                                                                {/* Başlat Raporu */}
                                                                <button
                                                                    className={`btn btn-icon btn-sm ${hasStartReport ? 'btn-success' : 'btn-light-primary'
                                                                        }`}
                                                                    title={hasStartReport ? 'Raporu Gör' : 'Sınav Başlatıldı'}
                                                                    onClick={() => openStartModal(ex)}
                                                                >
                                                                    <KTSVG
                                                                        path="/media/icons/duotune/general/gen026.svg"
                                                                        className="svg-icon-3"
                                                                    />
                                                                </button>

                                                                {/* Sorun Bildir */}
                                                                <button
                                                                    className={`btn btn-icon btn-sm ${hasIssue ? 'btn-danger' : 'btn-light-danger'
                                                                        }`}
                                                                    title={hasIssue ? 'Sorunu Gör' : 'Sorun Bildir'}
                                                                    onClick={() => openIssueModal(ex)}
                                                                >
                                                                    <KTSVG
                                                                        path="/media/icons/duotune/coding/cod007.svg"
                                                                        className="svg-icon-3"
                                                                    />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    );

                                                })}
                                            </li>
                                        );
                                    })
                            )}
                    </ul>
                </div>
            ));
    };



    const renderDutyCell = (date, time) => {
        const slot = dutyTimeSlots.find(s =>
            s.exactDate.startsWith(date) &&
            s.startTime === time.startTime &&
            s.endTime === time.endTime
        );
        if (!slot) return <div className="cell-content empty" />;
        const item = dutySchedule.find(d => d.slotId === slot.id) || {};
        if (!item.slotId) return <div className="cell-content empty" />;

        const hasRequest = !!swapStatuses[slot.id]?.hasRequest;

        return (
            <>
                <div className={`cell-content position-relative ${item.isOff ? 'off' : 'assigned'}`}>
                    {item.isOff
                        ? <em>Görevli (Diğer)</em>
                        : <>
                            <strong className="small">{item.roleName}</strong>
                            <span className="small">{item.examName}</span>
                        </>
                    }

                    {/* Değişim Talebi Iconu */}
                    {!item.isOff && item.examDeliveryMethod === 'EExamFaceToFace' && (
                        <span
                            className="position-absolute d-print-none bottom-0 start-0 btn btn-icon btn-sm m-2 ms-1 btn-light-primary"
                            style={{ cursor: 'pointer' }}
                            title="QR Oku"
                            onClick={() => openQrScanner(item)}
                        >
                            <i className="bi bi-qr-code-scan fs-5"></i>
                        </span>
                    )}
                    {!item.isOff && (
                        <span
                            className={`position-absolute d-print-none bottom-0 end-0 btn btn-icon btn-sm m-2 me-1 ${hasRequest ? 'btn-danger' : 'btn-black'} btn-bg-white btn-active-white btn-active-bg-black`}
                            style={{ cursor: 'pointer' }}
                            title="Değişim Talebi"
                            onClick={() => openSwapModal(slot)}
                        >
                            <KTSVG path='/media/icons/duotune/arrows/arr029.svg' className='svg-icon-3' />
                        </span>
                    )}
                </div>
            </>
        );
    };

    const renderCourseCell = (date, time) => {
        const slot = courseTimeSlots.find(s =>
            s.exactDate.startsWith(date) &&
            s.startTime === time.startTime &&
            s.endTime === time.endTime
        );
        if (!slot) return <div className="cell-content empty" />;
        const item = courseSchedule.find(c => c.slotId === slot.id) || {};
        if (!item.slotId) return <div className="cell-content empty" />;
        return (
            <div className="cell-content assigned">
                <strong className="small">{item.courseCode}</strong>
                <span className="small">{item.courseName}</span>
                <span className="small">{item.classroomCode} ({item.studentCount} kişi)</span>
            </div>
        );
    };

    // Yükleniyor spinner
    if ((activeTab === 'duties' && (isLoadingPeriods || isLoadingDuties)) ||
        (activeTab === 'courses' && (isLoadingPeriods || isLoadingCourses)) ||
        (activeTab === 'building' && (isLoadingPeriods || isLoadingBuilding)) ||
        (activeRuleScope && (examRulesApproval.isLoading || examRulesApproval.isPending))) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Yükleniyor...</span>
                </div>
            </div>
        );
    }

    if (activeRuleScope && !canViewActiveTab) {
        return (
            <div className="container mt-4">
                <div className="alert alert-warning" role="alert">
                    Bu döneme ait sınav bilgilerini ve görevlerinizi görüntüleyebilmek için sınav kurallarını okuyup onaylamanız gerekmektedir.
                </div>
                <ExamRulesApprovalModal
                    requirement={examRulesApproval.requirement}
                    error={examRulesApproval.error}
                    isAccepting={examRulesApproval.isAccepting}
                    onAccept={examRulesApproval.accept}
                    onRetry={examRulesApproval.reload}
                />
            </div>
        );
    }

    return (
        <>
            <div className="container mt-4">
                {/* Sekmeler (Hem desktop hem mobile) */}
                <div className="d-flex justify-content-end flex-wrap gap-2 mb-3 d-print-none">
                    <CalendarExportButton events={calendarEvents} fileName={calendarFileName} />
                    <button className="btn btn-outline-primary" onClick={() => window.print()}>
                        🖨️ Yazdır
                    </button>
                </div>
                {(myRequests.length > 0 || incomingRequests.length > 0) && (
                    <div className="d-print-none">
                        <SwapRequestsPanel
                            myRequests={myRequests}
                            incomingRequests={incomingRequests}
                            timeSlots={dutyTimeSlots}
                            onDecide={decideRequest}
                        />
                        <hr />
                    </div>
                )}
                <div className="d-print-none mb-4">
                    <SwapAdBoard
                        dutySchedule={dutySchedule}
                        timeSlots={dutyTimeSlots}
                        onUpdated={refreshDutyCalendarData}
                    />
                </div>
                <ul className="nav nav-tabs mb-3">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'duties' ? 'active' : ''}`}
                            onClick={() => setActiveTab('duties')}
                        >
                            Sınav Görevlerim
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'courses' ? 'active' : ''}`}
                            onClick={() => setActiveTab('courses')}
                        >
                            Verdiğim Derslerin Sınavları
                        </button>
                    </li>
                    {hasBuildingSupervisorRole && (
                        <li className="nav-item">
                            <button className={`nav-link ${activeTab === 'building' ? 'active' : ''}`} onClick={() => setActiveTab('building')}>Bina Sınav Sorumlusu</button>
                        </li>
                    )}
                </ul>

                {activeTab === 'duties' && publishedPeriods.length > 1 && (
                    <ul className="nav nav-tabs mb-3 d-md-none">
                        {publishedPeriods.map((period, index) => (
                            <li className="nav-item" key={period.id}>
                                <button
                                    className={`nav-link ${selectedDutyPeriodIndex === index ? 'active' : ''}`}
                                    onClick={() => {
                                        setSelectedDutyPeriodIndex(index);
                                        setAggregatedDuties([]);
                                    }}
                                >
                                    {period.name}
                                </button>
                            </li>
                        ))}
                    </ul>
                )}

                {activeTab === 'courses' && publishedPeriods.length > 1 && (
                    <ul className="nav nav-tabs mb-3 d-md-none">
                        {publishedPeriods.map((period, index) => (
                            <li className="nav-item" key={period.id}>
                                <button
                                    className={`nav-link ${selectedCoursePeriodIndex === index ? 'active' : ''}`}
                                    onClick={() => {
                                        setSelectedCoursePeriodIndex(index);
                                        setAggregatedCourses([]);
                                    }}
                                >
                                    {period.name}
                                </button>
                            </li>
                        ))}
                    </ul>
                )}

                {/* Masaüstü Görünüm - Görevler */}
                {activeTab === 'duties' && (
                    <div className="d-none d-md-block">
                        <h5>{publishedPeriods[selectedDutyPeriodIndex]?.name} Görev Takvimim</h5>
                        <ul className="nav nav-tabs mb-3">
                            {publishedPeriods.map((period, index) => (
                                <li className="nav-item" key={period.id}>
                                    <button
                                        className={`nav-link ${selectedDutyPeriodIndex === index ? 'active' : ''}`}
                                        onClick={() => setSelectedDutyPeriodIndex(index)}
                                    >
                                        {period.name}
                                    </button>
                                </li>
                            ))}
                        </ul>
                        {dutyWeeks.length > 1 && (
                            <div className="d-flex justify-content-between mb-2">
                                <button
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={() => setDutyCurrentWeek(w => Math.max(0, w - 1))}
                                    disabled={dutyCurrentWeek === 0}
                                >
                                    &larr; Önceki Hafta
                                </button>
                                <strong>
                                    {new Date(dutyWeeks[dutyCurrentWeek][0]).toLocaleDateString('tr-TR', {
                                        year: 'numeric', month: 'long', day: 'numeric'
                                    })}{' '}
                                    –{' '}
                                    {new Date(dutyWeeks[dutyCurrentWeek][6]).toLocaleDateString('tr-TR', {
                                        year: 'numeric', month: 'long', day: 'numeric'
                                    })}
                                </strong>
                                <button
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={() => setDutyCurrentWeek(w => Math.min(dutyWeeks.length - 1, w + 1))}
                                    disabled={dutyCurrentWeek === dutyWeeks.length - 1}
                                >
                                    Sonraki Hafta &rarr;
                                </button>
                            </div>
                        )}
                        <div style={{
                            overflowX: 'auto',
                            display: 'grid',
                            gridTemplateColumns: `120px repeat(${visibleDutyDays.length},1fr)`,
                            gridAutoRows: '100px',
                            gap: '1px',
                            background: '#ccc'
                        }}>
                            <div style={{ background: '#f1f1f1' }} />
                            {visibleDutyDays.map(date => (
                                <div key={date} style={{ background: '#f1f1f1', textAlign: 'center', padding: '4px' }}>
                                    {new Date(date).toLocaleDateString('tr-TR', {
                                        year: 'numeric', month: 'long', day: 'numeric'
                                    })}
                                </div>
                            ))}
                            {dutyDistinctTimes.map((time, idx) => (
                                <React.Fragment key={idx}>
                                    <div style={{
                                        background: '#f1f1f1',
                                        padding: '4px',
                                        border: '1px solid #bbb',
                                        fontSize: '0.9em',
                                        textAlign: 'center'
                                    }}>
                                        {time.startTime.substring(0, 5)} – {time.endTime.substring(0, 5)}
                                    </div>
                                    {visibleDutyDays.map(date => (
                                        <div key={date}>{renderDutyCell(date, time)}</div>
                                    ))}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                )}

                {/* Mobil Görünüm */}
                <div className="d-block">
                    {activeTab === 'duties' && mobileDutyDates.map(date => {
                        const dutiesForDate = aggregatedDuties.filter(d => d.date === date);
                        return (
                            <div className="ccd d-md-none">
                                <div className="print-spacer" />
                                <div key={date} className="card mb-5">
                                    <div style={{ minHeight: "40px" }} className="card-header bg-warning text-white text-center fw-bold">
                                        {new Date(date).toLocaleDateString('tr-TR', {
                                            year: 'numeric', month: 'long', day: 'numeric', weekday: 'long'
                                        })}
                                    </div>
                                    <ul className="list-group list-group-flush position-relative">
                                        {dutiesForDate.map((d, i) => {
                                            const hasRequest = !!swapStatuses[d.slotId];
                                            return (
                                                <li key={i} className="list-group-item position-relative">
                                                    {d.startTime.substring(0, 5)} – {d.endTime.substring(0, 5)}<br />
                                                    {d.isOff
                                                        ? <em>Görevli (Diğer)</em>
                                                        : <>
                                                            <strong>{d.roleName}</strong><br />
                                                            {d.examName}
                                                        </>}
                                                    {/* Değişim Talebi Iconu */}
                                                    {!d.isOff && d.examDeliveryMethod === 'EExamFaceToFace' && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-light-primary d-print-none mt-2"
                                                            onClick={() => openQrScanner(d)}
                                                        >
                                                            <i className="bi bi-qr-code-scan me-1"></i>
                                                            QR Oku
                                                        </button>
                                                    )}
                                                    {!d.isOff && (
                                                        <span
                                                            className={`
                                                                position-absolute d-print-none bottom-0 end-0 
                                                                btn btn-icon btn-sm m-2 me-1 
                                                                ${hasRequest ? 'btn-danger' : 'btn-black'} 
                                                                btn-bg-white btn-active-white btn-active-bg-black
                                                              `}
                                                            style={{ cursor: 'pointer' }}
                                                            title="Değişim Talebi"
                                                            onClick={() => openSwapModal(
                                                                { id: d.slotId, exactDate: d.date, startTime: d.startTime, endTime: d.endTime },
                                                                hasRequest
                                                            )}
                                                        >
                                                            <KTSVG path='/media/icons/duotune/arrows/arr029.svg'
                                                                className='svg-icon-3' />
                                                        </span>
                                                    )}
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            </div>
                        );
                    })}

                    {activeTab === 'courses' && mobileCourseDates.map(date => {
                        const examsForDate = aggregatedCourses.filter(c => c.date === date);

                        const grouped = examsForDate.reduce((acc, curr) => {
                            const key = `${curr.startTime}-${curr.endTime}-${curr.classroomCode}`;
                            if (!acc[key]) {
                                acc[key] = {
                                    startTime: curr.startTime,
                                    endTime: curr.endTime,
                                    classroomCode: curr.classroomCode,
                                    exams: []
                                };
                            }
                            // distinct kontrolü
                            if (!acc[key].exams.some(e =>
                                e.courseCode === curr.courseCode &&
                                e.examName === curr.examName &&
                                e.classroomCode === curr.classroomCode
                            )) {
                                acc[key].exams.push(curr);
                            }
                            return acc;
                        }, {});

                        //  li’leri oluşturmadan önce classroomCode’a göre sırala
                        const groupsSorted = Object.values(grouped)
                            .sort((a, b) =>
                                a.classroomCode.localeCompare(b.classroomCode)
                            );

                        return (
                            <div key={date} className="ccd">
                                <div className="print-spacer" />
                                <div className="card mb-5">
                                    <div
                                        style={{ minHeight: "40px" }}
                                        className="card-header bg-primary text-white text-center fw-bold"
                                    >
                                        {new Date(date).toLocaleDateString('tr-TR', {
                                            year: 'numeric', month: 'long', day: 'numeric', weekday: 'long'
                                        })}
                                    </div>
                                    <ul className="list-group list-group-flush">
                                        {groupsSorted.map((group, idx) => {
                                            // o sınıftaki toplam öğrenci sayısını hesapla
                                            const totalStudents = group.exams.reduce((sum, e) => sum + e.studentCount, 0);

                                            return (
                                                <li key={idx} className="list-group-item">
                                                    {/* Zaman */}
                                                    {group.startTime.substring(0, 5)} – {group.endTime.substring(0, 5)}<br />
                                                    {/* Derslik ve toplam öğrenci */}
                                                    <small className="text-muted">
                                                        {group.classroomCode} ({totalStudents} kişi)
                                                    </small><br />
                                                    {/* Sınavları virgülle listele */}
                                                    {group.exams.map((e, i) => (
                                                        <span key={i}>
                                                            <strong>{e.courseCode}</strong> {e.examName} ({e.studentCount} Kişi)
                                                            {i < group.exams.length - 1 && ', '}
                                                        </span>
                                                    ))}
                                                </li>
                                            );
                                        })}

                                    </ul>
                                </div>
                            </div>
                        );
                    }
                    )}

                    {activeTab === 'building' && (
                        <>
                            {buildingPeriods.length > 1 && (
                                <ul className="nav nav-tabs mb-3">
                                    {buildingPeriods.map((period, index) => (
                                        <li className="nav-item" key={period.id}>
                                            <button
                                                className={`nav-link ${selectedBuildingPeriodIndex === index ? 'active' : ''}`}
                                                onClick={() => {
                                                    setSelectedBuildingPeriodIndex(index);
                                                    setBuildingSchedule([]);
                                                }}
                                            >
                                                {period.name}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            )}
                            {/* Bina seçici */}
                            {supervisorBuildings.length > 1 && (
                                <div className="mb-3">
                                    <select
                                        className="form-select"
                                        value={selectedBuildingIndex}
                                        onChange={e => {
                                            setSelectedBuildingIndex(Number(e.target.value));
                                            setSelectedBuildingPeriodIndex(0);
                                            setBuildingSchedule([]);
                                        }}
                                    >
                                        {supervisorBuildings.map((b, i) => (<option key={b.id} value={i}>{b.name}</option>))}
                                    </select>
                                </div>
                            )}
                            {selectedBuildingPeriod ? renderBuildingRows() : <p className="text-muted">Bu bina için yayınlanmış dönem ataması yok.</p>}
                        </>
                    )}

                </div>
            </div>
            {showSwapModal && (
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 
                              bg-white bg-opacity-75 
                              d-flex align-items-center justify-content-center"
                    style={{ zIndex: 1040 }}
                >
                    <div
                        className="swap-request-modal position-relative"
                        style={{
                            zIndex: 1050,
                            width: '90%',       // mobil için daraltmak isteyebilirsiniz
                            maxWidth: '400px'   // geniş ekranlardaki maksimum genişlik
                        }}
                    >
                        <SwapRequestModal
                            show={showSwapModal}
                            onClose={() => setShowSwapModal(false)}
                            slotId={swapSlotId}
                            onUpdated={refreshDutyCalendarData}
                        />
                    </div>
                </div>
            )}

            {showStartModal && (
                <StartExamModal
                    show={showStartModal}
                    onClose={closeStartModal}
                    examInfo={selectedExam}
                    onSaved={handleModalSaved}
                />
            )}

            {/* Sorun Bildir */}
            {showIssueModal && (
                <IssueModal
                    show={showIssueModal}
                    onClose={closeIssueModal}
                    examInfo={selectedExam}
                    onSaved={handleModalSaved}
                />
            )}

            {showQrScanner && (
                <QrScannerModal
                    show={showQrScanner}
                    onClose={closeQrScanner}
                    examContext={qrExamContext}
                />
            )}
        </>
    );
}
